import { connect } from 'redux-bundler-react';
import ReadOnlyMap from '@components/map/readOnlyMap';
import { calculateGeometryExtent } from '@src/utils/helpers';
import './existingProjectTab.scss';
import LabelValue from '@components/label-value/LabelValue';

const truncateText = (text) => {
  const isLongText = typeof text === 'string' && text?.length > 350;

  if (isLongText) {
    return <div className='proj-scrollable-box'>{text}</div>;
  } else {
    return text;
  }
};

const getUniqueDaNumbers = (daNumbers) => {
  return [...new Set(daNumbers)].join(', ') || '—';
};

const ExistingProjectTab = connect(({ projectData }) => {
  return (
    <div className='proj-container'>
      <div>
        <section className='proj-section'>
          <h3> Project Location</h3>
          <div className='proj-flex-container'>
            <div className='proj-flex-item'>
              <ReadOnlyMap
                mapOnly
                geometry={projectData?.location?.geometry}
                extent={calculateGeometryExtent(projectData?.location?.geometry)}
                height='240px'
              />
            </div>
            <div className='proj-flex-item'>
              <div className='proj-flex-container'>
                <div className='proj-flex-item'>
                  <LabelValue label='Address' value={projectData?.location?.address} />
                  <LabelValue label='Address Line 2' value={projectData?.location?.addressTwo} />
                  <LabelValue label='City' value={projectData?.location?.city} />
                  <LabelValue label='State' value={projectData?.location?.state} />
                  <LabelValue label='Zip Code' value={projectData?.location?.zipcode} />
                </div>
                <div className='proj-flex-item'>
                  <LabelValue label='County' value={projectData?.location?.county} />
                  <LabelValue label='Country' value={projectData?.location?.country} />
                  <LabelValue label='District' value={projectData?.location?.district} />
                  <LabelValue label='Latitude' value={projectData?.location?.latitude} />
                  <LabelValue label='Longitude' value={projectData?.location?.longitude} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='proj-section flex-item'>
          <h3>Project Details</h3>
          <div className='proj-flex-container'>
            <div className='proj-flex-item'>
              <LabelValue label='Project Name' value={truncateText(projectData?.projectName)} />
              <LabelValue label='Project Description' value={truncateText(projectData?.projectDescription)} />
              <LabelValue label='Project Purpose' value={truncateText(projectData?.projectPurpose)} />
              <LabelValue label='Nature of Activity' value={truncateText(projectData?.natureOfActivity)} />
              <LabelValue label='DA Number' value={getUniqueDaNumbers(projectData?.daNumbers)} />
              <LabelValue label='Previous File Number(s)' value={projectData?.previousFileNumbers?.join(', ')} />
            </div>
            <div className='proj-flex-item'>
              <LabelValue label='Project Area (size)' value={projectData?.location?.projectArea} />
              <LabelValue label='Unit of Measurement' value={projectData?.location?.unitOfMeasurement} />
              <LabelValue label='Parcel Number' value={projectData?.parcelNumber} />
              <LabelValue label='Nearest Waterbody' value={projectData?.nearestWaterbody} />
              <LabelValue label='Directions to Project Location' value={truncateText(projectData?.siteDirections)} />
              <LabelValue label='Created Date' value={projectData?.createdDate} />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
});
export default ExistingProjectTab;
